import { render } from "./EditFournisseur.vue?vue&type=template&id=de6d9330&scoped=true&ts=true"
import script from "./EditFournisseur.vue?vue&type=script&lang=ts"
export * from "./EditFournisseur.vue?vue&type=script&lang=ts"

import "./EditFournisseur.vue?vue&type=style&index=0&id=de6d9330&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de6d9330"]])

export default __exports__